import { WechatFriendApplyData } from "../..";
import EventBus from "../event-bus";

const receiveNewFriendApplyHook = new EventBus<WechatFriendApplyData>(
  "receiveNewFriendApplyHook"
);

export default receiveNewFriendApplyHook;
